export enum GoFundMeFormInputNames {
  PageURL = 'gofundmeValue',
}
